import { Size, companyOtherNamesPath, t } from '@bms2/shared';
import { Button, TextInput } from '../../components/controls';
import { put } from './api';
import styles from './CompanyOtherNames.module.css';

/**
 * 🔒 Edit Company's Also Known As group (piece 13; decision 7150; T3026): the
 * other names the company goes by, each a plain line with its Remove, and Add
 * Name for one more. The note says they are read only when a person's employer
 * is checked. 🔨 The list is saved whole through its own route before the
 * record's own fields, so a refused name writes nothing.
 */
export interface CompanyOtherNamesProps {
  names: readonly string[];
  onChange: (names: string[]) => void;
}

export function CompanyOtherNames({ names, onChange }: CompanyOtherNamesProps) {
  const set = (index: number, value: string) => onChange(names.map((name, at) => (at === index ? value : name)));
  return (
    <div className={styles.group} data-company-other-names="true">
      <h3 className={styles.heading}>{t('companyOtherNames.heading')}</h3>
      <p className={styles.note}>{t('companyOtherNames.note')}</p>
      {names.map((name, index) => (
        <div key={index} className={styles.line} data-company-other-name={index}>
          <TextInput size={Size.Large} label={t('companyOtherNames.label')} value={name} onChange={(value) => set(index, value)} name={`otherName${index}`} />
          <Button size={Size.Small} text={[t('companyOtherNames.remove')]} actions={[() => onChange(names.filter((_, at) => at !== index))]} />
        </div>
      ))}
      <span>
        <Button size={Size.Small} text={[t('companyOtherNames.add')]} actions={[() => onChange([...names, ''])]} />
      </span>
    </div>
  );
}

/** Whether the list moved from what the form opened on. */
export function otherNamesChanged(initial: readonly string[], draft: readonly string[]): boolean {
  return initial.length !== draft.length || initial.some((name, index) => name.trim() !== (draft[index] ?? '').trim());
}

/** 🔒 The whole list sent once, its blank lines dropped, before the record's own Save. */
export function saveOtherNames(companyId: string, draft: readonly string[], apiBaseUrl: string) {
  return put<{ names: string[] }>(companyOtherNamesPath(companyId), { names: draft.map((name) => name.trim()).filter((name) => name !== '') }, apiBaseUrl);
}
